__turbopack_context__.v({
  "label": "styles-module__jvoOYa__label",
  "root": "styles-module__jvoOYa__root",
});
